<template>
    <app-layout ref="lo" title="Penyedia">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <form
                                    class="m-4"
                                    @submit.prevent="saveInfoCompletion"
                                >
<!--                                    <input type="hidden"  v-model="form.id" id="id">-->
                                    <div class="mb-3">
                                        <Message severity="warn">
                                            Agar dapat melanjutkan proses dengan cepat, harap diperhatikan untuk melengkapi seluruh data yang masih kurang dan mengunggah dokumen yang diperlukan sesegera mungkin. Terima kasih atas kerjasama Anda.
                                        </Message>
                                    </div>
                                <Accordion :multiple="true" :activeIndex="[0,7]">
                                    <AccordionTab header="Data Utama" :disabled="true">
                                        <div class="">
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nama_perusahaan"
                                                    value="Nama Perusahaan"
                                                />
                                                <Input
                                                    id="nama_perusahaan"
                                                    v-model="form.nama_perusahaan"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                                <InputError v-if="form.errors"
                                                    :message="form.errors.nama_perusahaan"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="npwp_perusahaan"
                                                    value="NPWP Perusahaan"
                                                />
                                                <Input
                                                    id="npwp_perusahaan"
                                                    v-model="form.npwp_perusahaan"
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                                <InputError v-if="form.errors"
                                                    :message="form.errors.npwp_perusahaan"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nama_pemberi_kuasa"
                                                    value="Nama Direktur"
                                                />
                                                <Input
                                                    id="nama_pemberi_kuasa"
                                                    v-model="form.nama_pemberi_kuasa"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                    required="required"
                                                />
                                                <InputError v-if="form.errors"
                                                    :message="form.errors.nama_pemberi_kuasa"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nama_penerima_kuasa"
                                                    value="Nama Penerima Kuasa"
                                                />
                                                <Input
                                                    id="nama_penerima_kuasa"
                                                    v-model="form.nama_penerima_kuasa"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                    required="required"
                                                />
                                                <InputError v-if="form.errors"
                                                    :message="form.errors.nama_penerima_kuasa"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="alamat_perusahaan"
                                                    value="Alamat Perusahaan"
                                                />
                                                <Input
                                                    id="alamat_perusahaan"
                                                    v-model="form.alamat_perusahaan"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                    required="required"
                                                />
                                                <InputError v-if="form.errors"
                                                    :message="form.errors.alamat_perusahaan"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="alamat_perusahaan_semarang"
                                                    value="Alamat Perusahaan Semarang"
                                                />
                                                <Input
                                                    id="alamat_perusahaan_semarang"
                                                    v-model="form.alamat_perusahaan_semarang"
                                                    type="text"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"

                                                />
                                                <InputError v-if="form.errors"
                                                    :message="form.errors.alamat_perusahaan_semarang"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="jenis_pekerjaan"
                                                    value="Jenis Pekerjaan"
                                                />
                                                <Dropdown class="w-full md:w-14rem" v-model="form.jenis_pekerjaan" :options="selectJenis_pekerjaan" optionLabel="nama_pekerjaan" placeholder="Pilih Jenis Pekerjaan" >
                                                    <template #option="slotProps">
                                                        <div class="country-item">
                                                            <div>{{slotProps.option.nama_pekerjaan}}</div>
                                                        </div>
                                                    </template>
                                                    <template #selectedItem="slotProps">
                                                        <div class="country-item selected">
                                                            <div>{{slotProps.option.nama_pekerjaan}}</div>
                                                        </div>
                                                    </template>

                                                </Dropdown>
                                                <InputError
                                                    :message="form.errors.jenis_pekerjaan"
                                                    class="mt-2"
                                                />
                                            </div>
                                        </div>
                                        <div class="mt-6 lg:w-full md:w-full">
                                            <div class="flex flex-col mb-6">
                                                <div class="w-full px-3 text-center">
                                                    <ButtonSave @click="saveInfoCompletion" label="Simpan Data Utama" />
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Data File Tambahan">
                                        <div class="">
                                            <Dialog v-model:visible="isDialogVisible" modal :style="{ width: '50vw' }">
                                                <!-- Tampilkan rincian item yang dipilih di sini -->
                                                <pdf :src="'/storage/'+handleHashing(penyedia.id)+'/'+selectedItem" />
                                            </Dialog>
                                            <div class="field w-full px-3 mb-3" v-for="formId in formIds" :key="formId.nama">
                                                <JetLabel
                                                    class="w-full"
                                                    :for="formId.nama"
                                                    :value="formId.label + ' (bisa lebih dari 1 File .pdf Max 5MB)'"
                                                />
                                                <DataTable :value="localDataPenyediaFile['penyedia_file_'+formId.nama]" tableStyle="min-width: 50rem">
                                                    <!-- Kolom untuk file name -->
                                                    <Column field="fileName" header="File Name">
                                                        <template #body="slotProps">
                                                            {{ slotProps.data }}
                                                        </template>
                                                    </Column>

                                                    <!-- Kolom untuk tombol delete -->
                                                    <Column field="id" header="Actions" :sortable="true">
                                                        <template #body="slotProps">
                                                            <ButtonShow label="Lihat" @click="showDialog(slotProps.index, formId.nama)" />
                                                            <ButtonDelete label="Delete" @click="deleteItem(slotProps.data, formId.nama)" />
                                                        </template>
                                                    </Column>
                                                </DataTable>
                                                <Input
                                                    :id="formId.nama"
                                                    type="file"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    accept="application/pdf"
                                                    multiple="true"
                                                    @change="event => uploadFiles(event, penyedia.id, formId.nama)"
                                                    lang="id"
                                                />
<!--          css garis pemisah-->
                                                <div class="border-b border-gray-600">&nbsp;</div>
                                            </div>
                                        </div>
                                    </AccordionTab>
<!--                                    <AccordionTab header="Data File Tambahan" >-->

<!--                                        <div class="">-->
<!--                                            <div class="field w-full px-3 mb-3">-->
<!--                                                <JetLabel-->
<!--                                                    class="w-full"-->
<!--                                                    for="akta_notaris"-->
<!--                                                    value="Akta Notaris (bisa lebih dari 1 File .pdf Max 5MB)"-->
<!--                                                />-->
<!--                                              <ul id="example-1">-->
<!--                                                <li v-for="(item, index) in dataPenyediaFile.penyedia_file_akta_notaris" :key="item.id">-->
<!--                                                  <ButtonShow v-bind:label="item" @click="visible1[index] = true" />-->
<!--                                                  <Dialog v-model:visible="visible1[index]" modal v-bind:header="item" :style="{ width: '50vw' }">-->
<!--                                                    <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+item" />-->
<!--                                                  </Dialog>-->
<!--                                                </li>-->
<!--                                              </ul>-->
<!--                                                <Input-->
<!--                                                    id="akta_notaris"-->
<!--                                                    type="file"-->
<!--                                                    @input="form.akta_notaris = $event.target.files"-->
<!--                                                    placeholder="(optional)"-->
<!--                                                    class="mt-1 block w-full"-->
<!--                                                    accept="application/pdf"-->
<!--                                                    multiple="true"-->
<!--                                                />-->
<!--                                                <InputError v-if="form.errors"-->
<!--                                                    :message="form.errors.akta_notaris"-->
<!--                                                    class="mt-2"-->
<!--                                                />-->
<!--                                            </div>-->
<!--                                            <div class="field w-full px-3 mb-3">-->
<!--                                                <JetLabel-->
<!--                                                    class="w-full"-->
<!--                                                    for="nib"-->
<!--                                                    value="NIB dan Ijin Usaha Liannya (bisa lebih dari 1 File .pdf Max 5MB)"-->
<!--                                                />-->
<!--                                                <ul id="example-1">-->
<!--                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_nib" :key="item.id">-->
<!--                                                        <ButtonShow v-bind:label="item" @click="visible2[index] = true" />-->
<!--                                                        <Dialog v-model:visible="visible2[index]" modal v-bind:header="item" :style="{ width: '50vw' }">-->
<!--                                                            <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+item" />-->
<!--                                                        </Dialog>-->
<!--                                                    </li>-->
<!--                                                </ul>-->
<!--                                                <Input-->
<!--                                                    id="nib"-->
<!--                                                     type="file"-->
<!--                                                    @input="form.nib = $event.target.files"-->
<!--                                                    placeholder="(optional)"-->
<!--                                                    class="mt-1 block w-full"-->
<!--                                                    accept="application/pdf"-->
<!--                                                    multiple="true"-->
<!--                                                />-->
<!--                                                <InputError v-if="form.errors"-->
<!--                                                    :message="form.errors.nib"-->
<!--                                                    class="mt-2"-->
<!--                                                />-->
<!--                                            </div>-->
<!--                                            <div class="field w-full px-3 mb-3">-->
<!--                                                <JetLabel-->
<!--                                                    class="w-full"-->
<!--                                                    for="perhitungan_kemampuan_dasar"-->
<!--                                                    value="Perhitungan Kemampuan Dasar (bisa lebih dari 1 File .pdf Max 5MB)"-->
<!--                                                />-->

<!--                                                <ul id="example-1">-->
<!--                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_perhitungan_kemampuan_dasar" :key="item.id">-->
<!--                                                        <ButtonShow v-bind:label="item" @click="visible3[index] = true" />-->
<!--                                                        <Dialog v-model:visible="visible3[index]" modal v-bind:header="item" :style="{ width: '50vw' }">-->
<!--                                                            <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+item" />-->
<!--                                                        </Dialog>-->
<!--                                                    </li>-->
<!--                                                </ul>-->

<!--                                                <Input-->
<!--                                                    id="perhitungan_kemampuan_dasar"-->
<!--                                                     type="file"-->
<!--                                                    @input="form.perhitungan_kemampuan_dasar = $event.target.files"-->
<!--                                                    placeholder="(optional)"-->
<!--                                                    class="mt-1 block w-full"-->
<!--                                                    accept="application/pdf"-->
<!--                                                    multiple="true"-->
<!--                                                />-->
<!--                                                <InputError v-if="form.errors"-->
<!--                                                    :message="form.errors.perhitangan_kemampuan_dasar"-->
<!--                                                    class="mt-2"-->
<!--                                                />-->
<!--                                            </div>-->
<!--                                            <div class="field w-full px-3 mb-3">-->
<!--                                                <JetLabel-->
<!--                                                    class="w-full"-->
<!--                                                    for="indikator_keuangan"-->
<!--                                                    value="Indikator Keuangan (SKN) (bisa lebih dari 1 File .pdf Max 5MB)"-->
<!--                                                />-->

<!--                                                <ul id="example-1">-->
<!--                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_indikator_keuangan" :key="item.id">-->
<!--                                                        <ButtonShow v-bind:label="item" @click="visible4[index] = true" />-->
<!--                                                        <Dialog v-model:visible="visible4[index]" modal v-bind:header="item" :style="{ width: '50vw' }">-->
<!--                                                            <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+item" />-->
<!--                                                        </Dialog>-->
<!--                                                    </li>-->
<!--                                                </ul>-->
<!--                                                <Input-->
<!--                                                    id="indikator_keuangan "-->
<!--                                                    type="file"-->
<!--                                                    @input="form.indikator_keuangan = $event.target.files"-->
<!--                                                    placeholder="(optional)"-->
<!--                                                    class="mt-1 block w-full"-->
<!--                                                    accept="application/pdf"-->
<!--                                                    multiple="true"-->
<!--                                                />-->
<!--                                                <InputError v-if="form.errors"-->
<!--                                                    :message="form.errors.indikator_keuangan"-->
<!--                                                    class="mt-2"-->
<!--                                                />-->
<!--                                            </div>-->
<!--                                            <div class="field w-full px-3 mb-3">-->
<!--                                                <JetLabel-->
<!--                                                    class="w-full"-->
<!--                                                    for="spt_badan"-->
<!--                                                    value="SPT Badan beserta lampiran (bisa lebih dari 1 File .pdf Max 5MB)"-->
<!--                                                />-->
<!--                                                <ul id="example-1">-->
<!--                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_spt_badan" :key="item.id">-->
<!--                                                        <ButtonShow v-bind:label="item" @click="visible10[index] = true" />-->
<!--                                                        <Dialog v-model:visible="visible10[index]" modal v-bind:header="item" :style="{ width: '50vw' }">-->
<!--                                                            <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+item" />-->
<!--                                                        </Dialog>-->
<!--                                                    </li>-->
<!--                                                  </ul>-->
<!--                                                <Input-->
<!--                                                    id="spt_badan"-->
<!--                                                    type="file"-->
<!--                                                    multiple="true"-->
<!--                                                    @input="form.spt_badan = $event.target.files"-->
<!--                                                    placeholder="(optional)"-->
<!--                                                    class="mt-1 block w-full"-->
<!--                                                    accept="application/pdf"-->
<!--                                                />-->
<!--                                                <InputError v-if="form.errors"-->
<!--                                                    :message="form.errors.spt_badan"-->
<!--                                                    class="mt-2"-->
<!--                                                />-->
<!--                                            </div>-->
<!--                                            <div class="field w-full px-3 mb-3">-->
<!--                                                <JetLabel-->
<!--                                                    class="w-full"-->
<!--                                                    for="rekening_koran"-->
<!--                                                    value="Rekening koran 3 bulan terakhir (bisa lebih dari 1 File .pdf Max 5MB)"-->
<!--                                                />-->
<!--                                                <ul id="example-1">-->
<!--                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_rekening_koran" :key="item.id">-->
<!--                                                        <ButtonShow v-bind:label="item" @click="visible11[index] = true" />-->
<!--                                                        <Dialog v-model:visible="visible11[index]" modal v-bind:header="item" :style="{ width: '50vw' }">-->
<!--                                                            <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+item" />-->
<!--                                                        </Dialog>-->
<!--                                                    </li>-->
<!--                                                </ul>-->
<!--                                                <Input-->
<!--                                                    id="rekening_koran"-->
<!--                                                    type="file"-->
<!--                                                    multiple="true"-->
<!--                                                    @input="form.rekening_koran = $event.target.files"-->
<!--                                                    placeholder="(optional)"-->
<!--                                                    class="mt-1 block w-full"-->
<!--                                                    accept="application/pdf"-->
<!--                                                />-->
<!--                                                <InputError v-if="form.errors"-->
<!--                                                            :message="form.errors.rekening_koran"-->
<!--                                                            class="mt-2"-->
<!--                                                />-->
<!--                                            </div>-->
<!--                                            <div class="field w-full px-3 mb-3">-->
<!--                                                <JetLabel-->
<!--                                                    class="w-full"-->
<!--                                                    for="laporan_keuangan_audited"-->
<!--                                                    value="Laporan Keuangan Audited ( kalau ada bisa lebih dari 1 File .pdf Max 5MB)"-->
<!--                                                />-->
<!--                                                <ul id="example-1">-->
<!--                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_laporan_keuangan_audited" :key="item.id">-->
<!--                                                        <ButtonShow v-bind:label="item" @click="visible12[index] = true" />-->
<!--                                                        <Dialog v-model:visible="visible12[index]" modal v-bind:header="item" :style="{ width: '50vw' }">-->
<!--                                                            <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+item" />-->
<!--                                                        </Dialog>-->
<!--                                                    </li>-->
<!--                                                </ul>-->
<!--                                                <Input-->
<!--                                                    id="laporan_keuangan_audited"-->
<!--                                                    type="file"-->
<!--                                                    multiple="true"-->
<!--                                                    @input="form.laporan_keuangan_audited = $event.target.files"-->
<!--                                                    placeholder="(optional)"-->
<!--                                                    class="mt-1 block w-full"-->
<!--                                                    accept="application/pdf"-->
<!--                                                />-->
<!--                                                <InputError v-if="form.errors"-->
<!--                                                            :message="form.errors.laporan_keuangan_audited"-->
<!--                                                            class="mt-2"-->
<!--                                                />-->
<!--                                            </div>-->
<!--                                            <div class="field w-full px-3 mb-3">-->
<!--                                                <JetLabel-->
<!--                                                    class="w-full"-->
<!--                                                    for="laporan_keuangan_unaudited"-->
<!--                                                    value="Laporan Keuangan Unaudited (bisa lebih dari 1 File .pdf Max 5MB)"-->
<!--                                                />-->
<!--                                                <ul id="example-1">-->
<!--                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_laporan_keuangan_unaudited" :key="item.id">-->
<!--                                                        <ButtonShow v-bind:label="item" @click="visible13[index] = true" />-->
<!--                                                        <Dialog v-model:visible="visible13[index]" modal v-bind:header="item" :style="{ width: '50vw' }">-->
<!--                                                            <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+item" />-->
<!--                                                        </Dialog>-->
<!--                                                    </li>-->
<!--                                                </ul>-->
<!--                                                <Input-->
<!--                                                    id="laporan_keuangan_unaudited"-->
<!--                                                    type="file"-->
<!--                                                    multiple="true"-->
<!--                                                    @input="form.laporan_keuangan_unaudited = $event.target.files"-->
<!--                                                    placeholder="(optional)"-->
<!--                                                    class="mt-1 block w-full"-->
<!--                                                    accept="application/pdf"-->
<!--                                                />-->
<!--                                                <InputError v-if="form.errors"-->
<!--                                                            :message="form.errors.laporan_keuangan_unaudited"-->
<!--                                                            class="mt-2"-->
<!--                                                />-->
<!--                                            </div>-->
<!--                                            <div class="field w-full px-3 mb-3">-->
<!--                                                <JetLabel-->
<!--                                                    class="w-full"-->
<!--                                                    for="dokumen_lain"-->
<!--                                                    value="Dokumen Lainnya (bisa lebih dari 1 File .pdf Max 5MB)"-->
<!--                                                />-->
<!--                                                <ul id="example-1">-->
<!--                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_dokumen_lain" :key="item.id">-->
<!--                                                        <ButtonShow v-bind:label="item" @click="visible5[index] = true" />-->
<!--                                                        <Dialog v-model:visible="visible5[index]" modal v-bind:header="item" :style="{ width: '50vw' }">-->
<!--                                                            <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+item" />-->
<!--                                                        </Dialog>-->
<!--                                                    </li>-->
<!--                                                </ul>-->
<!--                                                <Input-->
<!--                                                    id="dokumen_lain"-->
<!--                                                    type="file"-->
<!--                                                    multiple="true"-->
<!--                                                    @input="form.dokumen_lain = $event.target.files"-->
<!--                                                    placeholder="(optional)"-->
<!--                                                    class="mt-1 block w-full"-->
<!--                                                    accept="application/pdf"-->
<!--                                                />-->
<!--                                                <InputError v-if="form.errors"-->
<!--                                                            :message="form.errors.dokumen_lain"-->
<!--                                                            class="mt-2"-->
<!--                                                />-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="mt-6 lg:w-full md:w-full">-->
<!--                                            <div class="flex flex-col mb-6">-->
<!--                                                <div class="w-full px-3 text-center">-->
<!--                                                    <ButtonSave @click="saveInfoCompletion" label="Simpan Data File" />-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </AccordionTab>-->
                                    <AccordionTab header="Data Pegawai / Tenaga Ahli" >
                                        <div class="">
                                            <div class="form-group">
                                                <ConfirmDialog></ConfirmDialog>
                                                <DataTable :value="dataPenyediaPegawai" tableStyle="min-width: 50rem">
                                                    <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header"></Column>
                                                    <Column field="file_pegawai" header="File Pegawai" :sortable="true">
                                                        <template #body="slotProps">
                                                            <!-- {{ slotProps.data }} -->
                                                            <ButtonShow @click="visible6[slotProps.data.id] = true" />
                                                                <Dialog v-model:visible="visible6[slotProps.data.id]" modal v-bind:header="slotProps.data.id" :style="{ width: '50vw' }">
                                                                    <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+slotProps.data.file_pegawai" />
                                                                </Dialog>
                                                        </template>
                                                    </Column>
                                                    <Column field="id" header="aksi" :sortable="true">
                                                        <template #body="slotProps">

                                                            <ButtonDelete label="hapus" @click="deletePenyediaPegawai(slotProps.data)" />
                                                        </template>
                                                    </Column>
                                                </DataTable>
                                                <InputRepeaterPegawai v-model="form.data_pegawai" ></InputRepeaterPegawai>

                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Data Kontrak">
                                        <div class="">
                                            <div class="form-group">
                                                <DataTable :value="dataPenyediaKontrakHistori" tableStyle="min-width: 50rem">
                                                    <Column v-for="col of columns2" :key="col.field" :field="col.field" :header="col.header"></Column>
                                                    <Column field="file_kontrak" header="File Kontrak" :sortable="true">
                                                        <template #body="slotProps">
                                                            <!-- {{ slotProps.data }} -->
                                                            <ButtonShow @click="visible7[slotProps.data.id] = true" />
                                                                <Dialog v-model:visible="visible7[slotProps.data.id]" modal v-bind:header="slotProps.data.id" :style="{ width: '50vw' }">
                                                                    <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+slotProps.data.file_kontrak" />
                                                                </Dialog>
                                                        </template>
                                                    </Column>
                                                    <Column field="file_bast" header="File BAST" :sortable="true">
                                                        <template #body="slotProps">
                                                            <!-- {{ slotProps.data }} -->
                                                            <ButtonShow @click="visible8[slotProps.data.id] = true" />
                                                                <Dialog v-model:visible="visible8[slotProps.data.id]" modal v-bind:header="slotProps.data.id" :style="{ width: '50vw' }">
                                                                    <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+slotProps.data.file_bast" />
                                                                </Dialog>
                                                        </template>
                                                    </Column>
                                                    <Column field="id" header="aksi" :sortable="true">
                                                        <template #body="slotProps">
                                                            <ButtonDelete label="hapus" @click="deletePenyediaKontrakHistori(slotProps.data)" />
                                                        </template>
                                                    </Column>
                                                </DataTable>
                                                <InputRepeaterKontrak v-model="form.data_kontrak" ></InputRepeaterKontrak>

                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Data Barang / Peralatan" >
                                        <div class="">
                                            <div class="form-group">
                                                <DataTable :value="dataPenyediaBarang" tableStyle="min-width: 50rem">
                                                    <Column v-for="col of columns3" :key="col.field" :field="col.field" :header="col.header"></Column>
                                                    <Column field="id" header="aksi" :sortable="true">
                                                        <template #body="slotProps">
                                                            <ButtonDelete label="hapus" @click="deletePenyediaBarang(slotProps.data)" />
                                                        </template>
                                                    </Column>
                                                </DataTable>
                                                <InputRepeaterBarang v-model="form.data_barang" ></InputRepeaterBarang>

                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Data KBLI">
                                        <div class="">
                                            <div class="form-group">
                                                <DataTable :value="dataPenyediaKbli" tableStyle="min-width: 50rem">
                                                    <Column v-for="col of columns4" :key="col.field" :field="col.field" :header="col.header"></Column>
                                                    <Column field="id" header="aksi" :sortable="true">
                                                        <template #body="slotProps">
                                                            <ButtonDelete label="hapus" @click="deletePenyediaKbli(slotProps.data)" />
                                                        </template>
                                                    </Column>
                                                </DataTable>
                                                <InputRepeaterKbli v-model="form.data_kbli" :old_kbli="dataPenyediaKbli"></InputRepeaterKbli>

                                            </div>
                                        </div>
                                    </AccordionTab>

                                    <AccordionTab header="Catatan TIM DRM" v-if="$page.props.session_role.role.name != 'penyedia'">
                                        <div class="field w-full px-3 mb-3">
                                            <JetLabel
                                                class="w-full"
                                                for="catatan"
                                                value="Catatan TIM DRM(1 File .pdf)"
                                            />
                                            <ButtonShow v-bind:label="dataPenyediaFile.penyedia_file_catatan" @click="visible9 = true" />
                                            <Dialog v-model:visible="visible9" modal v-bind:header="dataPenyediaFile.penyedia_file_catatan" :style="{ width: '50vw' }">
                                                <pdf v-bind:src="'/storage/'+handleHashing(penyedia.id)+'/'+dataPenyediaFile.penyedia_file_catatan" />
                                            </Dialog>
                                            <Input
                                                id="catatan"
                                                type="file"
                                                @input="form.catatan = $event.target.files[0]"
                                                placeholder="(optional)"
                                                class="mt-1 block w-full"
                                                accept="application/pdf"
                                            />
                                            <InputError v-if="form.errors"
                                                        :message="form.errors.catatan"
                                                        class="mt-2"
                                            />
                                        </div>
                                    </AccordionTab>
                                </Accordion>
                                    <div class="mt-6 lg:w-full md:w-full">
                                        <div class="flex flex-col mb-6">
                                            <div class="w-full px-3 text-center">
                                                <ButtonSave @click="saveInfoCompletion" label="Simpan Data Lainnya" />
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import ButtonSave from "@/Components/ButtonSave.vue";
import InputRepeaterPegawai from "@/Pages/Penyedia/InputRepeaterPegawai.vue";
import InputRepeaterKontrak from "@/Pages/Penyedia/InputRepeaterKontrak.vue";
import InputRepeaterBarang from "@/Pages/Penyedia/InputRepeaterBarang.vue";
import InputRepeaterKbli from "@/Pages/Penyedia/InputRepeaterKbli.vue";
import InputMask from 'primevue/inputmask';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import FileUpload from 'primevue/fileupload';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ButtonShow from "@/Components/ButtonShow";
import Button from 'primevue/button';
import ButtonDelete from "@/Components/ButtonDelete";
import pdf from "@/Components/Pdf.vue";
import Dialog from 'primevue/dialog';
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import md5Hex from 'md5-hex';
import Dropdown from 'primevue/dropdown';
// import penyedia from "@/Pages/Penyedia/index.vue";
import Message from 'primevue/message';



export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        JetLabel,
        Input,
        InputError,
        ButtonSave,
        InputRepeaterPegawai,
        InputRepeaterKontrak,
        InputRepeaterBarang,
        InputRepeaterKbli,
        InputMask,
        Accordion,
        AccordionTab,
        FileUpload,
        DataTable,
        Column,
        ButtonShow,
        pdf,
        Dialog,
        ButtonDelete,
        ConfirmDialog,
        ConfirmPopup,
        Dropdown,
        // penyedia,
        Message,

    },
    props: {
            penyedia : Object,
            dataPenyediaBarang : Object,
            dataPenyediaPegawai : Object,
            dataPenyediaKontrakHistori : Object,
            dataPenyediaKbli : Object,
            dataPenyediaFile : Object,
            selectJenis_pekerjaan : Object,

        },
    data() {
        return {
            form: this.$inertia.form({
                _method: "POST",
                id:null,
                nama_perusahaan:null,
                npwp_perusahaan:null,
                nama_pemberi_kuasa:null,
                nama_penerima_kuasa:null,
                alamat_perusahaan:null,
                alamat_perusahaan_semarang:null,
                data_pegawai:[],
                data_kontrak:[],
                data_barang:[],
                data_kbli:[],
                // akta_notaris:[],
                // catatan:[],
                // nib:[],
                // perhitungan_kemampuan_dasar:[],
                // indikator_keuangan:[],
                // dokumen_lain:[],
                // rekening_koran:[],
                // laporan_keuangan_audited:[],
                // laporan_keuangan_unaudited:[],
                // spt_badan:[],
                jenis_pekerjaan:null,

            }),
            visible1: [],
            visible2: [],
            visible3: false,
            visible4: false,
            visible5: [],
            visible6: [],
            visible7: [],
            visible8: [],
            visible9: false,
            visible10: [],
            visible11: [],
            visible12: [],
            visible13: [],
            columns :[
                { field: 'nama_pegawai', header: 'Nama Pegawai' },
                { field: 'nik_pegawai', header: 'NIK Pegawai' },
                { field: 'pendidikan_pegawai', header: 'Pendidikan Pegawai' },
                { field: 'keahlian_pegawai', header: 'Keahlian Pegawai' },
            ],
            columns2 :[
                { field: 'nomor_kontrak', header: 'Nomor Kontrak' },
                { field: 'nomor_bast', header: 'Nomor BAST' },
                { field: 'pemberi_kerja', header: 'Pemberi Kerja' },
            ],
            columns3 :[
                { field: 'nama_barang', header: 'Nama Barang' },
                { field: 'jumlah', header: 'Jumlah' },
            ],
            columns4 :[
                { field: 'kode_kbli', header: 'Kode KBLI' },
                { field: 'judul_kbli', header: 'Judul KBLI' },
                { field: 'keterangan_kbli', header: 'Keterangan KBLI' },
            ],
            formIds: [
                { nama: 'akta_notaris', label: 'Akta Notaris' },
                { nama: 'nib', label: 'Nomor Induk Berusaha (NIB)' },
                { nama: 'perhitungan_kemampuan_dasar', label: 'Perhitungan Kemampuan Dasar' },
                { nama: 'indikator_keuangan', label: 'Indikator Keuangan' },
                { nama: 'dokumen_lain', label: 'Dokumen Lain' },
                { nama: 'rekening_koran', label: 'Rekening Koran' },
                { nama: 'laporan_keuangan_audited', label: 'Laporan Keuangan Audited' },
                { nama: 'laporan_keuangan_unaudited', label: 'Laporan Keuangan Unaudited' },
                { nama: 'spt_badan', label: 'Surat Pemberitahuan (SPT) Badan' },

            ],

            localDataPenyediaFile: this.dataPenyediaFile,
            isDialogVisible: false,
            selectedItem: null,

                // Confirm : useConfirm(),

        };
    },
    mounted(){
        console.log(this.formIds);
        this.form.nama_perusahaan = this.penyedia.nama_perusahaan;
        this.form.npwp_perusahaan = this.penyedia.npwp_perusahaan;
        this.form.nama_pemberi_kuasa = this.penyedia.nama_pemberi_kuasa;
        this.form.nama_penerima_kuasa = this.penyedia.nama_penerima_kuasa;
        this.form.alamat_perusahaan = this.penyedia.alamat_perusahaan;
        this.form.alamat_perusahaan_semarang = this.penyedia.alamat_perusahaan_semarang;
        this.form.jenis_pekerjaan = this.penyedia.jenis_pekerjaan;

        this.form.id = this.penyedia.id;
        // this.localDataPenyediaFile = this.dataPenyediaFile;

        // this.form = this.penyedia;
        // console.log(this.form);
        // this.form.data_pegawai = this.dataPenyediaPegawai;
        // this.form.data_kontrak = this.dataPenyediaKontrakHistori;
        // this.form.data_barang = this.dataPenyediaBarang;
        // this.form.data_kbli = this.dataPenyediaKbli;
        // this.form.data_file = this.dataPenyediaFile;
    },
    methods: {
        handleHashing(data) {
            this.hashedMessage = md5Hex(data);
            // console.log(md5Hex(data));
            return this.hashedMessage;
        },
        saveInfoCompletion: function(){
            // console.log(this.form);
            // this.form.post(this.route(`penyedia.updateData`), this.form);
            this.form.post(route("penyedia.updateData"), {
                errorBag: "saveInfoCompletion",
                preserveScroll: true,
                onSuccess: () => {
                    //redirect
                    this.$toast.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Data berhasil disimpan",
                        life: 3000,
                    });
                    //redirect to penyedia
                    // setTimeout(() => {
                    //    // redirect penyedia/ id
                    //     console.log(this.penyedia.id);
                    //     this.$inertia.get(this.route('penyedia.edit', {'id' : this.penyedia.id}));
                    // }, 2000);

                },
                onFinish: () => {
                    //
                },
            });

        },
        deletePenyediaPegawai: function (event) {
            // console.log(event);
            console.log(event);

            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Delete "+ event.nama_pegawai +" ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    //axios delete data pegawai
                    axios.post(this.route('penyedia.deletePenyediaPegawai',{'id' : event.id}))
                        .then(response => {
                            // console.log(response);
                            this.$toast.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: "Data berhasil dihapus",
                                life: 3000,
                            });
                            //redirect to penyedia
                            setTimeout(() => {
                                // redirect penyedia/ id
                                this.$inertia.get(this.route('penyedia.edit', {'id' : this.penyedia.id}));
                            });
                        })
                        .catch(error => {
                            console.log(error);
                        });
                },
                reject: () => {
                    //
                },
            });
        },
        deletePenyediaBarang: function (event) {
            // console.log(event);
            console.log(event);

            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Delete "+ event.nama_barang +" ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    //axios delete data barang
                    axios.post(this.route('penyedia.deletePenyediaBarang',{'id' : event.id}))
                        .then(response => {
                            // console.log(response);
                            this.$toast.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: "Data berhasil dihapus",
                                life: 3000,
                            });
                            //redirect to penyedia
                            setTimeout(() => {
                                // redirect penyedia/ id
                                this.$inertia.get(this.route('penyedia.edit', {'id' : this.penyedia.id}));
                            });
                        })
                        .catch(error => {
                            console.log(error);
                        });
                },
                reject: () => {
                    //
                },
            });
        },
        deletePenyediaKontrakHistori: function (event) {
            // console.log(event);
            console.log(event);

            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Delete "+ event.nomor_kontrak +" ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    axios.post(this.route('penyedia.deletePenyediaKontrakHistori',{'id' : event.id}))
                        .then(response => {
                            // console.log(response);
                            this.$toast.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: "Data berhasil dihapus",
                                life: 3000,
                            });
                            //redirect to penyedia
                            setTimeout(() => {
                                // redirect penyedia/ id
                                this.$inertia.get(this.route('penyedia.edit', {'id' : this.penyedia.id}));
                            });
                        })
                        .catch(error => {
                            console.log(error);
                        });
                },
                reject: () => {
                    //
                },
            });
        },
        deletePenyediaKbli: function (event) {
            // console.log(event);
            console.log(event);

            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Delete "+ event.kode_kbli +" ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-danger",
                accept: () => {
                    axios.post(this.route('penyedia.deletePenyediaKbli',{'id' : event.id}))
                        .then(response => {
                            // console.log(response);
                            this.$toast.add({
                                severity: "success",
                                summary: "Success Message",
                                detail: "Data berhasil dihapus",
                                life: 3000,
                            });
                            //redirect to penyedia
                            setTimeout(() => {
                                // redirect penyedia/ id
                                this.$inertia.get(this.route('penyedia.edit', {'id' : this.penyedia.id}));
                            });
                        })
                        .catch(error => {
                            console.log(error);
                        });
                },
                reject: () => {
                    //
                },
            });
        },
        reset() {
            fire.$emit('reset');
        },
        async uploadFiles(event, idPenyedia, formId) {
            const formData = new FormData();
            const files = event.target.files;

            for (let i = 0; i < files.length; i++) {
                formData.append(`files[]`, files[i]);
            }

            formData.append('id_penyedia', idPenyedia);
            formData.append('jenis_file', formId);

            try {
                // Use Axios for the request
                const response = await axios.post(this.route('penyedia.upload'), formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });

                this.$toast.add({
                    severity: "success",
                    summary: "Success Message",
                    detail: "Data berhasil disimpan",
                    life: 3000,
                });
                //redirect to penyedia
                // setTimeout(() => {
                //     // redirect penyedia/ id
                //     this.$inertia.get(this.route('penyedia.edit', {'id' : this.penyedia.id}));
                // }, 2000);
                this.fetchUpdatedData();
            } catch (error) {
                // console.error(`Error uploading files for form ${formId} and id_penyedia ${idPenyedia}:`, error);
                //menampilkan error
                this.$toast.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: formId+" File gagal diupload",
                    life: 3000,
                });
            }

            // Reset the input to allow selecting the same files again
            event.target.value = '';
        },

        //fetchFile
        async fetchUpdatedData() {
            // Implement logic to fetch and update data without reloading the page
            // For example, make another Axios request to get the latest data
            try {
                const updatedData = await axios.get(this.route('penyedia.fetchFile'), {
                    params: {
                        id: this.penyedia.id,
                    },
                });
                // ubah data penyediaFile dengan data updatedData
                this.localDataPenyediaFile = updatedData.data;

            } catch (error) {
                console.error('Error fetching updated data:', error);
            }
        },

        showDialog(index, formId) {
            // Set selectedItem based on the selected item
            this.selectedItem = this.localDataPenyediaFile['penyedia_file_'+formId][index];
            console.log(this.selectedItem);
            // Show the dialog
            this.isDialogVisible = true;
        },
        // deleteItem
        async deleteItem(nama_file,jenis_file){
            try {
                // Use Axios for the request
                const isConfirmed = window.confirm('Yakin mau dihapus?');
                if (isConfirmed) {
                    const response = await axios.post(this.route('penyedia.deleteFile'), {
                        nama_file: nama_file,
                        jenis_file: jenis_file,
                        id_penyedia: this.penyedia.id,
                    });
                }else{
                    return;
                }

                this.$toast.add({
                    severity: "success",
                    summary: "Success Message",
                    detail: "File "+jenis_file+" "+nama_file+" berhasil dihapus",
                    life: 3000,
                });

                this.fetchUpdatedData();
            } catch (error) {
                console.error(`Error deleting files for form ${this.selectedItem.jenis_file} and id_penyedia ${this.selectedItem.id_penyedia}:`, error);
                //menampilkan error
                this.$toast.add({
                    severity: "error",
                    summary: "Error Message",
                    detail: this.selectedItem.jenis_file+" File gagal dihapus",
                    life: 3000,
                });
            }

        },

    },
});
</script>
